import React, { useState, useEffect, useCallback } from 'react';
import { Divider, Select, Space, Button } from 'antd';
import { IoFilter } from "react-icons/io5";
import Modal from 'react-bootstrap/Modal';
import Tabs from '../HealthQuatationPage/Tabs';
import TabsBike from './TabsBike/TabsBike';
import axios from 'axios';
import apiUrls from '../../Api/MainApi';
// import Tabs from './Tabs';

function BikeFIlter({ storageChange, setStorageChange }) {

    const [items, setItems] = useState(['Low to high', 'High to low']);
    const [filterValue, setFilterValue] = useState({
        planName: null
    })
    const [plan, setPlan] = useState([]);
    const [insurer, setInsurer] = useState([]);
    const [period, setPeriod] = useState(["1 year", "2 year", "3 year"])
    const [applyAddOnChange, setApplyAddOnChange] = useState(null) // to store the data from the carTabs component and then set it to session Storage
    const applyFilter = () => {
        // Logic to apply filter
        console.log('Filter applied');
    };
    // for modal 
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const fetchInsurerData = useCallback(async () => {
        const insurerResponse = await axios.get(apiUrls.GetInsurerMasterDropDown)
        setInsurer(insurerResponse.data.data)
    }, [])

    useEffect(() => {
        const fetchPolicyType = async () => {
            const policyResponse = await axios.post(apiUrls.GetProductDropDown, { name: 'Car' });
            const datas = policyResponse.data.data;
            setPlan(datas);
            console.log(datas)
        }
        fetchPolicyType()
        fetchInsurerData()
    }, [fetchInsurerData])
    const handlePolicyTypeChange = (selectedValue) => {
        setFilterValue(prev => ({
            ...prev,
            planName: selectedValue
        }))
        const data = JSON.parse(sessionStorage.getItem("BikeQuotationRequest"));
        const updatedData = {
            ...data,
            InsurerProductID: selectedValue,
        };
        sessionStorage.setItem("BikeQuotationRequest", JSON.stringify(updatedData));
        setStorageChange(true)
    }

    const applyAddonChange = () => {  // to change the sessionStorage according to the addons selected
        if (applyAddOnChange) {
            sessionStorage.setItem("BikeQuotationRequest", JSON.stringify(applyAddOnChange));
            setStorageChange(true)
            setShow(false)
        } else {
            const data = JSON.parse(sessionStorage.getItem("BikeQuotationRequest"));
            sessionStorage.setItem("BikeQuotationRequest", JSON.stringify(data));
            setShow(false)
        }
    }
    const handleResetButton = () => {
        const data = JSON.parse(sessionStorage.getItem("BikeQuotationRequest"));
        const updatedData = {
            ...data,
            cngSelection: false,
            consumablesSelection: false,
            engineProtectionSelection: false,
            keyAndLockProtectSelection: false,
            partsDepreciationSelection: false,
            personalBelongingSelection: false,
            returnToInvoiceSelection: false,
            rimProtectionSelection: false,
            roadSideAssistanceSelection: false,
            //accessories
            tyreProtectionSelection: false,
            electricalSelection: false,
            nonElectricalSelection: false,
            // legal liabilities
            cleanersLLSelection: false,
            employeesLLSelection: false,
            nonFarePaxLLSelection: false,
            paidDriverLLSelection: false,
            unnamedPaxLLSelection: false,
            workersCompensationLLSelection: false,
            // unNamed Pa
            unnamedCleanerSelection: false,
            unnamedConductorSelection: false,
            unnamedHirerSelection: false,
            unnamedPaidDriverSelection: false,
            unnamedPaxSelection: false,
            unnamedPillionRiderSelection: false,
        }
        sessionStorage.setItem("BikeQuotationRequest", JSON.stringify(updatedData));
        setShow(false);
    }
    return (

        <div className='quick-filter-background'>
            <div className='container'>
                <div className='row align-items-center'>
                    <div className='col-1 mt-3'>
                        <h6>Quick Filter</h6>
                    </div>
                    <div className='col-8 mt-2'>
                        <div className='filter-wrapper d-flex gap-4'>
                            <Select
                                style={{ width: 150 }}
                                className='antd-dropdown'
                                placeholder="Relevance"
                                dropdownRender={(menu) => (
                                    <>
                                        {menu}
                                    </>
                                )}
                                options={items.map((item) => ({
                                    label: item,
                                    value: item,
                                }))}
                            />

                            <Select
                                name="Policy type"
                                style={{ width: 170 }}
                                className='antd-dropdown'
                                onChange={handlePolicyTypeChange}
                                options={(plan.length > 0 ? plan : [{ id: 0, name: "No type Found" }]).map(plan => ({ key: `plan-${plan.id}`, value: plan.id, label: plan.name }))}
                                placeholder="Select Policy Type"
                            />
                            <Select
                                style={{ width: 300 }}
                                // mode='tags'
                                className='antd-dropdown'
                                maxTagCount={1}
                                placeholder="Insurer"
                                dropdownRender={(menu) => (
                                    <>
                                        {menu}
                                    </>
                                )}
                                options={insurer.map((item) => ({
                                    label: item.name,
                                    value: item.name,
                                }))}
                            />
                            <Select
                                style={{ width: 170 }}
                                className='antd-dropdown'
                                placeholder="Policy Period"
                                dropdownRender={(menu) => (
                                    <>
                                        {menu}
                                    </>
                                )}
                                options={period.map((item) => ({
                                    label: item,
                                    value: item,
                                }))}
                            />
                        </div>
                    </div>
                    <div className='col-2 mt-2'>
                        <button className="posp-button" onClick={handleShow}>
                            <IoFilter className='' fontSize={15} />   All Addons
                        </button>
                        <Modal centered size="lg" show={show} onHide={handleClose} animation={true}>
                            <Modal.Header closeButton>
                                <Modal.Title>Filter Plans By</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <TabsBike setStorageChange={setStorageChange} setApplyAddOnChange={setApplyAddOnChange} />
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="danger" onClick={handleResetButton}>
                                    Reset
                                </Button>
                                <Button variant="success" onClick={applyAddonChange}>
                                    Apply Filter
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BikeFIlter;
